export class VisualizationHistogramTimePoint {
    'date';
    'value';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "date",
            "baseName": "date",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VisualizationHistogramTimePoint.attributeTypeMap;
    }
    constructor() {
    }
}
